import React from "react";
var __jsx = React.createElement;
import Column from './Column';
function LayoutTwoColText(_ref) {
  var yextInfo = _ref.yextInfo,
    isLoading = _ref.isLoading;
  return __jsx(React.Fragment, null, __jsx(Column, {
    isLoading: isLoading,
    className: "l-col-full lg:l-col-6",
    yextInfo: yextInfo,
    headlineFieldId: "c_websiteBannerExpandedFirstColumnHeadline",
    textFieldId: "c_websiteBannerExpandedFirstColumnText"
  }), __jsx(Column, {
    isLoading: isLoading,
    className: "l-col-full lg:l-col-6",
    yextInfo: yextInfo,
    headlineFieldId: "c_websiteBannerExpandedSecondColumnHeadline",
    textFieldId: "c_websiteBannerExpandedSecondColumnText"
  }));
}
export default LayoutTwoColText;